<template>
    <div>
        <el-row>
            <el-col :span="24" style="text-align: left; padding-top: 30px;">
                <span class="mainTitle">
                    Industry News
                </span>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24"  style="text-align: left;padding:20px 60px;">
                <span  class="mainContent">
                    <el-table :data="tableData" border style="width: 100%">
                        <el-table-column prop="title" label="Title"  style="width: 70%" />
                        <!-- <el-table-column prop="createdUserName" label="Publisher" style="width: 15%" /> -->
                        <el-table-column prop="createdTime" label="Date"  style="width: 30%"/>
                        <el-table-column fixed="right" label="Operation" width="120">
                        <template #default="scope">
                            <el-button link type="primary" size="small" @click="handleClickDetail( scope.row )">Detail</el-button>
                        </template>
                        </el-table-column>
                    </el-table>
                    <div class="example-pagination-block">
                        <el-pagination layout="prev, pager, next" :total="this.totalRows" />
                    </div>
                </span>
            </el-col>
        </el-row>
    </div>
    <el-dialog v-model="dialogFormVisible" width="80%" title="News Detail">
        <el-row>
            <el-col :span="24" class="newsTitleArea">
                <span class="newsMainTitle">News Title：{{ currentDetial.title }}</span><br>
                <span class="newsSubTitle">：{{ currentDetial.title }}</span>
            </el-col>
            <el-col :span="24" class="newsContentArea">
                <span class="newsContent">{{ currentDetial.content }}</span><br>
                <div class="newsImageArea" v-show="tempPicUrl.length !== 0">
                    <el-image
                    style="width: 300px; height: 200px"
                    :src="tempPicUrl[0]"
                    :zoom-rate="1.2"
                    :max-scale="7"
                    :min-scale="0.2"
                    :preview-src-list="tempPicUrl"
                    :initial-index="tempPicUrl.length"
                    fit="cover"
                    />
                </div>
            </el-col>
        </el-row>
        <template #footer>
        <span class="dialog-footer">
            <el-button @click="dialogFormVisible = false">close</el-button>
        </span>
        </template>
    </el-dialog>
</template>

<script>
import api from '@/api/api'
    export default {
        name: "en_corecompetence",
        components: {},
        data() {
            return {
                tableData:[
                ],
                totalPage:1,
                totalRows:1,
                PageNo:1,
                PageSize:10,
                dialogFormVisible:false,
                currentDetial:{},
                tempPicUrl:[]
            }
        },
        
        created(){
            this.initNewsList()
        },
        mounted(){
            
        },
        methods:{
            initNewsList() {
                this.getNewList();
            },
            async getNewList(){
                let data = {
                    pageNo: 1,
                    pageSize: 10,
                    searchParameters: [
                        {
                            "field": "lang",
                            "op": 0,
                            "value": "en"
                        }, 
                    ]
                };
                let _res = await api.postNewsListD( data );
                let _resData = _res.data;
                if ( _resData.success) {
                    this.tableData = _resData.data.rows;
                    this.totalPage = _resData.data.totalPage;
                    this.totalRows =_resData.data.totalRows;
                    this.PageNo =_resData.data.pageNo;
                    this.PageSize = _resData.data.pageSize;
                }
            },
            handleClickDetail( row ) {
                this.dialogFormVisible = true;
                this.currentDetial = row;
                this.tempPicUrl = [];
                this.currentDetial.attchs.forEach( e => {
                    this.getImage( e ); 
                });
            },
            async getImage( id ) {
                if (id) {
                    let _tempRes = await api.getSysFileInfoPreview({id: id});
                    if ( _tempRes.status === 200 ) {
                        return this.tempPicUrl.push(window.URL.createObjectURL(new Blob([_tempRes.data])));
                    } else {
                        return '--';
                    }
                } else {
                    return "No Images"
                }
            },
        }
    }
</script>

<style scoped>
.newsTitleArea {
    text-align: left;
}
.newsTitleArea .newsMainTitle {
    font-size: x-large;
    line-height: 2em;
}
.newsTitleArea .newsSubTitle {
    font-size: x-small;
    color: #ccc;
}
.newsContentArea {
    text-align: left;
    margin-top: 1em;
}
.newsContentArea .newsContent {
    color: #333;
    font-size: medium;
}
.newsContentArea .newsImageArea {
    margin-top: 2em;
}
.el-image{
    border: 1px solid #999;
}
</style>